/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_African_Languages21Inputs */

const en__field_enum_study_african_languages21 = /** @type {(inputs: _Field_Enum_Study_African_Languages21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`African Languages, Media and Communication`)
};

const de__field_enum_study_african_languages21 = /** @type {(inputs: _Field_Enum_Study_African_Languages21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikanische Sprachen, Medien und Kommunikation`)
};

/**
* | output |
* | --- |
* | "African Languages, Media and Communication" |
*
* @param {_Field_Enum_Study_African_Languages21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_african_languages21 = /** @type {((inputs?: _Field_Enum_Study_African_Languages21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_African_Languages21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_african_languages21(inputs)
	return de__field_enum_study_african_languages21(inputs)
});
export { _field_enum_study_african_languages21 as "_field_enum_STUDY_AFRICAN_LANGUAGES" }